import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  signInWithEmailAndPassword,
  getAuth,
  signInWithPopup,
  GoogleAuthProvider
} from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import './LoginForm.css';
import logoClaro from '../images/Logo.png';
import logoDark from '../img/logoDark.png';
import LoadingScreen from './loading';
import { FaGoogle, FaSignInAlt } from 'react-icons/fa'; // NUEVO
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);
const googleProvider = new GoogleAuthProvider();

const LoginForm = ({ handleTabChange }) => {
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [logo, setLogo] = useState(logoClaro);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleLoginSubmit();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);

  }, [loginForm]);
  useEffect(() => {
    if (localStorage.getItem('darkMode') === 'true') {
      setLogo(logoDark);
    } else {
      setLogo(logoClaro);
    }
  }, []);

  const handleLoginChange = (e) => {
    const { id, value } = e.target;
    setLoginForm((prevState) => ({ ...prevState, [id]: value }));
    setError('');
  };

  const handleLoginSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    try {
      const credentials = await signInWithEmailAndPassword(auth, loginForm.email, loginForm.password);
      const user = credentials.user;

      if (!user.emailVerified) {
        setError('Correo no verificado. Por favor verifica tu correo.');
        setIsLoading(false);
        return;
      }

      localStorage.setItem('currentUserEmail', loginForm.email);
      localStorage.setItem('currentUserId', user.uid);

      const userDocRef = doc(db, 'usuarios', user.uid);
      const docSnap = await getDoc(userDocRef);

      if (docSnap.exists()) {
        await updateDoc(userDocRef, { lastConnection: new Date().toISOString() });
      }

      redirect();
    } catch {
      setError('Usuario o contraseña incorrectos.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userDocRef = doc(db, 'usuarios', user.uid);
      const docSnap = await getDoc(userDocRef);
      const validityTime = 30; // Días de vigencia
      const fechaExpiracion = new Date();
      fechaExpiracion.setDate(fechaExpiracion.getDate() + validityTime);
      if (!docSnap.exists()) {
        await setDoc(userDocRef, {
          name: user.displayName || 'Usuario',
          email: user.email,
          role: 'user',
          photoURL: user.photoURL || '',
          lastConnection: new Date().toISOString(),
        });
        toast.success(`🎉 ¡Bienvenido a La OFI.WORK! Por tu registro has ganado ${500} coins.`);

      } else {
        await updateDoc(userDocRef, { lastConnection: new Date().toISOString() });
      }

      localStorage.setItem('currentUserEmail', user.email);
      localStorage.setItem('currentUserId', user.uid);

      redirect();
    } catch (error) {
      console.error('Error en autenticación con Google:', error);
      setError('No se pudo iniciar sesión con Google.');
    } finally {
      setIsLoading(false);
    }
  };

  const redirect = () => {
    const verify = localStorage.getItem('verify');
    const url = localStorage.getItem('url');


    if (localStorage.getItem('isClaiming') === 'true') {
      navigate('/procesar-reclamo');
    } 
    if (verify === "true" && url) {
      try {
        navigate(url);
        localStorage.removeItem('verifiy');
        localStorage.removeItem('url');
      } catch {
        navigate('/wallet');
      }
      
    } else {
      navigate('/wallet');
    }
  };

  return (
    <div className="auth-wrapper">
      <ToastContainer />

      <div className="auth-card">
        <img src={logo} alt="logo" className="logo-login" />
        <h2 className="auth-title">¡Bienvenido de nuevo!</h2>
        <p className="auth-description">Inicia sesión para acceder a tu cuenta de laofi.work</p>

        {error && (
          <div className="auth-alert">
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleLoginSubmit} className="auth-form">
          <div className="floating-label2">
            <input
              id="email"
              type="email"
              value={loginForm.email}
              onChange={handleLoginChange}
              required
              placeholder=" "
              className={error ? 'error' : ''}
            />
            <label htmlFor="email">Email</label>
          </div>

          <div className="floating-label2">
            <input
              id="password"
              type="password"
              value={loginForm.password}
              onChange={handleLoginChange}
              required
              placeholder=" "
              className={error ? 'error' : ''}
            />
            <label htmlFor="password">Contraseña</label>
          </div>

          <div className="forgot-password text-right">
            <span className="clickable" onClick={() => handleTabChange('olvidasteContrasenia')}>
              ¿Olvidaste tu contraseña?
            </span>
          </div>
          <button type="submit" className="full-width btn-auth" disabled={isLoading}>
            {isLoading ? 'Cargando...' : (
              <>
                <FaSignInAlt style={{ marginRight: '8px' }} />
                Iniciar sesión
              </>
            )}
          </button>


          <div className="divider">
            <span>O continúa con</span>
          </div>

          <button type="button" className="btn-google full-width" onClick={handleGoogleLogin} disabled={isLoading}>
            {isLoading ? 'Cargando...' : (
              <>
                <FaGoogle style={{ marginRight: '8px' }} />
                Iniciar sesión con Google
              </>
            )}
          </button>

          {isLoading && <LoadingScreen />}

          <p className="auth-footer">
            ¿No tienes una cuenta?{' '}
            <span className="clickable" onClick={() => handleTabChange('register')}>Regístrate</span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
